import { __awaiter, __generator, __read, __spread } from "tslib";
/* eslint-disable no-await-in-loop */
import { useRef } from 'react';
import { useSleep } from '../useSleep';
/**
 * retry times when exec callback fail
 *
 * * `retry`: that will auto add `times` end of your call back
 * * `cancel`: cancel that retry event, that only cancel inner interval promise, **if you need cancel your `cb` promise, you should handle by yourself.**
 */
export var useRetry = function (
/**
 * exec callback, when you want to end that retry, return `true` with your callback
 */
cb, 
/** retry options */
options) {
    var _a = useSleep(), sleep = _a.sleep, cancelSleep = _a.cancel;
    var isCancelRef = useRef(true);
    var complete = function () {
        var _a;
        isCancelRef.current = true;
        (_a = options === null || options === void 0 ? void 0 : options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
    };
    var cancel = function () {
        var _a;
        if (!isCancelRef.current) {
            // * when outside cancel
            (_a = options === null || options === void 0 ? void 0 : options.onCancel) === null || _a === void 0 ? void 0 : _a.call(options);
            complete === null || complete === void 0 ? void 0 : complete();
        }
        cancelSleep();
    };
    var retry = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var retryTimes, intervalTime, onSuccess, i, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cancel();
                        isCancelRef.current = false;
                        (_a = options === null || options === void 0 ? void 0 : options.onStart) === null || _a === void 0 ? void 0 : _a.call(options);
                        return [4 /*yield*/, cb.apply(void 0, __spread(args))];
                    case 1:
                        // * when exec success, just return directly.
                        if (_c.sent()) {
                            if (!isCancelRef.current) {
                                (_b = options === null || options === void 0 ? void 0 : options.onSuccess) === null || _b === void 0 ? void 0 : _b.call(options);
                                complete();
                            }
                            return [2 /*return*/];
                        }
                        if (!options)
                            return [2 /*return*/];
                        retryTimes = options.retryTimes, intervalTime = options.intervalTime, onSuccess = options.onSuccess;
                        i = 0;
                        _c.label = 2;
                    case 2:
                        if (!(i < retryTimes)) return [3 /*break*/, 9];
                        if (isCancelRef.current) {
                            return [2 /*return*/];
                        }
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, sleep(intervalTime)];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _c.sent();
                        return [2 /*return*/];
                    case 6: return [4 /*yield*/, cb.apply(void 0, __spread(args, [i]))];
                    case 7:
                        if (_c.sent()) {
                            if (!isCancelRef.current) {
                                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                                complete();
                            }
                            return [2 /*return*/];
                        }
                        _c.label = 8;
                    case 8:
                        i++;
                        return [3 /*break*/, 2];
                    case 9:
                        complete();
                        return [2 /*return*/];
                }
            });
        });
    };
    return {
        /**
         * retry method, that will be cancelable with `cancel`,
         * and when trigger many time that will always clear previous retry
         */
        retry: retry,
        /**
         * cancel current retry
         */
        cancel: cancel,
    };
};
